var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.billingMaintenanceFeatureFlagEnabled(_vm.currentAppConfig)
    ? _c("div", [
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center mb-3 pt-4" },
              [
                _c("b-spinner", {
                  staticStyle: { width: "5rem", height: "5rem" },
                  attrs: { variant: "warning", label: "Spinning" }
                })
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "ml-3 mr-3",
                  attrs: { rounded: "lg", id: "overlay" }
                },
                [
                  _c("div", { staticClass: "row no-gutters mb-2 mt-4" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "h1",
                        {
                          staticClass: "mb-0 pb-0",
                          attrs: { "data-test-hook": "pageTitle" }
                        },
                        [
                          _c("i", {
                            staticClass: "far fa-badge-dollar pr-1",
                            attrs: { "data-test-hook": "titleIcon" }
                          }),
                          _c(
                            "span",
                            {
                              attrs: {
                                "data-test-hook": "subscription-plan-details"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("xManageYourPlan")))]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm.showSubscriptionProcessingBanner
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "pl-1" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "pt-3", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass: "alert alert-info mb-0",
                                      attrs: { show: "" }
                                    },
                                    [
                                      _c("b-row", { staticClass: "mb-2" }, [
                                        _c("i", {
                                          staticClass:
                                            "far fa-circle-exclamation ml-2"
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t(
                                                "xProcessingSubscriptionInformation"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "ml-3",
                                          staticStyle: {
                                            "font-weight": "normal !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("xProcessingPlanChange")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dunningSubscription
                    ? _c("DunningSubscriptionBanner", {
                        attrs: { dunningSubscription: _vm.dunningSubscription }
                      })
                    : _vm._e(),
                  _vm._l(_vm.expiredDealerManagedApparatuses, function(
                    expiredApparatus,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: "expired-" + index },
                      [
                        _c("ExpiredDealerManagedBanner", {
                          attrs: {
                            expiredDealerManagedApparatus: expiredApparatus
                          }
                        })
                      ],
                      1
                    )
                  }),
                  (_vm.numberOfApparatusInNeedOfAttention > 0 ||
                    (_vm.apparatusMultiplePlans !== null &&
                      _vm.premiumSubscriptionApparatusMultiplePlans)) &&
                  _vm.isAccountAddressAmericaOrCanada
                    ? _c("AccountNeedsAttentionBanner", {
                        attrs: {
                          productsOnBasicSubscriptionOrNotInPlan:
                            _vm.productsOnBasicSubscriptionOrNotInPlan,
                          apparatusesNeedsAttention:
                            _vm.premiumApparatusesNeedsAttention,
                          apparatusHasMultipleSubscriptions:
                            _vm.apparatusMultiplePlans,
                          premiumSubscriptionApparatusMultiplePlans:
                            _vm.premiumSubscriptionApparatusMultiplePlans,
                          allValidApparatusesOnAccount: _vm.apparatuses,
                          currentSubscription: _vm.subsForPremiumPlanCard?.filter(
                            sub =>
                              sub.subscriptionStatus !==
                                _vm.subscriptionDetailCanceled &&
                              sub.subscriptionStore !== _vm.dealerStore
                          )[0],
                          subscriptionDetails: _vm.subscriptionDetails,
                          disableUpgradeButton:
                            _vm.showSubscriptionProcessingBanner ||
                            _vm.subscriptionCancelInitiated === true
                        },
                        on: {
                          openCancelPlanMultiplePlansModal:
                            _vm.openCancelPlanMultiplePlansModal,
                          openRemoveApparatusMultiplePlansModal:
                            _vm.openRemoveApparatusMultiplePlansModal
                        }
                      })
                    : _vm._e(),
                  !_vm.doesAccountHaveAnyProducts() &&
                  !_vm.hasPendingCanceledSub()
                    ? _c("NoProductsOnAccount")
                    : _vm._e(),
                  _vm._l(_vm.productsDealerManaged, function(
                    productDealerManaged,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("DealerManaged", {
                          attrs: { productDealerManaged: productDealerManaged }
                        })
                      ],
                      1
                    )
                  }),
                  _vm.legacySubscriptionList?.length > 0
                    ? _c("LegacySubscriptionList", {
                        attrs: {
                          subscriptionList:
                            _vm.legacySubscriptionList !== undefined
                              ? _vm.legacySubscriptionList
                              : []
                        },
                        on: {
                          openCancelSubscriptionModal:
                            _vm.openCancelSubscriptionModal
                        }
                      })
                    : _vm._e(),
                  this.subsForPremiumPlanCard?.length > 0 ||
                  (!_vm.doesAccountHaveAnyProducts() &&
                    _vm.hasPendingCanceledSub())
                    ? _c("PremiumPlan", {
                        attrs: {
                          subscription: _vm.subsForPremiumPlanCard?.filter(
                            sub =>
                              sub.subscriptionStatus !==
                              _vm.subscriptionDetailCanceled
                          )[0],
                          apparatusesNeedsAttention:
                            _vm.premiumApparatusesNeedsAttention,
                          premiumSubscriptionApparatusMultiplePlans:
                            _vm.premiumSubscriptionApparatusMultiplePlans
                        },
                        on: {
                          openCancelPlanMultiplePlansModal:
                            _vm.openCancelPlanMultiplePlansModal,
                          openManagePlanModal: _vm.openManagePlanModal
                        }
                      })
                    : _vm._e(),
                  _vm.productsOnBasicSubscriptionOrNotInPlan?.length > 0 &&
                  !_vm.hasPartiallyEnrolledTank(_vm.apparatuses)
                    ? _c("HasProductNoSubscription", {
                        attrs: {
                          productsOnBasicSubscriptionOrNotInPlan:
                            _vm.productsOnBasicSubscriptionOrNotInPlan,
                          apparatusesOnExistingSubscription:
                            _vm.apparatusesOnExistingSubscription,
                          legacySubscriptionList: _vm.legacySubscriptionList,
                          accountProfile: _vm.accountProfile,
                          showBasicSubscriptionCard:
                            _vm.showBasicSubscriptionCard,
                          disableUpgradeButton:
                            _vm.showSubscriptionProcessingBanner
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.v1FuelMonitors, function(v1FuelMonitor, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("HasV1FuelMonitor", {
                          attrs: { v1FuelMonitor: v1FuelMonitor }
                        })
                      ],
                      1
                    )
                  }),
                  _c("CancelSubscriptionModal", {
                    attrs: {
                      isCancelLegacy: _vm.isCancelLegacy,
                      endDate: _vm.endDate,
                      cancelLegacyApparatusId:
                        _vm.cancelLegacyApparatusId !== undefined
                          ? _vm.cancelLegacyApparatusId
                          : null,
                      cancelLegacyApparatusType:
                        _vm.cancelLegacyApparatusType !== undefined
                          ? _vm.cancelLegacyApparatusType
                          : null,
                      cancelSubscriptionApparatuses:
                        _vm.cancelSubscriptionApparatuses !== null
                          ? _vm.cancelSubscriptionApparatuses
                          : [],
                      cancelSubscriptionProductId:
                        _vm.cancelSubscriptionProductId !== undefined
                          ? _vm.cancelSubscriptionProductId
                          : null,
                      cancelSubscriptionStore:
                        _vm.cancelSubscriptionStore !== undefined
                          ? _vm.cancelSubscriptionStore
                          : null
                    }
                  }),
                  _c("CancelPremiumPlanApparatusMultiplePlansModal", {
                    attrs: {
                      accountProfile: _vm.accountProfile,
                      apparatus: _vm.apparatusMultiplePlans,
                      currentPremiumSubscription:
                        _vm.premiumSubscriptionApparatusMultiplePlans,
                      immediatelyOpen:
                        this.apparatusMultipleSubs !== undefined &&
                        this.apparatusMultipleSubs !== null
                    }
                  }),
                  _c("AccountNeedsAttentionModal")
                ],
                2
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }